declare global {
  interface Window {
    openCXoneChat?: () => void;
    showCXoneBubble: () => void;
    forceShow: boolean;
    isMinimizing: boolean;
  }
}

const showMessenger = (defaultTrigger?: () => void) => {
  if (typeof window !== "undefined" && window.openCXoneChat) {
    window.openCXoneChat();
  } else if (defaultTrigger) {
    defaultTrigger();
  }
};

export { showMessenger };
